export default "__VITE_ASSET__AqB9vZSz__"